/**
 * journey-ux/BulkBar.jsx — bulk-action toolbar (Phase 1)
 *
 * Visible only when one or more rows are selected. Lives in the filter
 * row's right slot. Per DESIGN_DECISIONS.md D-6, bulk actions are always
 * exposed inline — never behind a "…" menu.
 */
import React from 'react';

export const BulkBar = ({ selectedCount = 0, actions = [], testId = 'bulk-bar' }) => {
  if (selectedCount === 0) return null;
  return (
    <div
      data-testid={testId}
      className="flex items-center gap-1.5"
    >
      <span className="text-[11px] text-slate-600 font-medium pr-1">
        {selectedCount} selected
      </span>
      {actions.map((a) => (
        <button
          key={a.id}
          type="button"
          onClick={a.onClick}
          data-testid={`${testId}-${a.id}`}
          className={`text-[11px] px-2 py-1 rounded transition-colors ${
            a.primary
              ? 'bg-slate-900 text-white hover:bg-slate-800'
              : 'text-slate-600 hover:bg-slate-100'
          }`}
        >
          {a.label}
        </button>
      ))}
    </div>
  );
};

export default BulkBar;
